import React from "react"
import { IconSeeker, LoadingIconSeeker } from "@ui-seeker/core"
import { AppPageTabs } from "@components"
import { batch } from "@preact/signals-react"

import { ALERTS } from "Pages/ReportsAlerts/Alerts/@constants"
import { clearSignals } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import {
	alertsSection,
	isMinMaxPriceTabEmpty,
	isMinMaxPriceTabLoading,
	isNoAvailabilityTabEmpty,
	isNoAvailabilityTabLoading,
	isPriceChangeTabEmpty,
	isPriceChangeTabLoading,
	isPriceComparisonTabEmpty,
	isPriceComparisonTabLoading,
	isRatingTabEmpty,
	isRatingTabLoading
} from "Pages/ReportsAlerts/Alerts/@signals"


// The icon of each alert type: its tab and the title of its table
export const ALERTS_ICONS = {
	[ALERTS.PRICE_COMPARISON]: 'hand-holding-dollar',
	[ALERTS.NO_AVAILABILITY]: 'circle-xmark',
	[ALERTS.PRICE_CHANGE]: 'money-bill-1-wave',
	[ALERTS.MIN_MAX_PRICE]: 'plus-minus',
	[ALERTS.RATING]: 'star-half-stroke',
}

export default function AlertsTabs() {

	const setTab = (_, value) => batch(() => {
		clearSignals()
		alertsSection.value = value
	})

	// They sit in the white band of the page, aligned with what is beside them
	return <AppPageTabs
		stackProps={{ sx: { mb: 0 } }}
		onChange={setTab}
		value={alertsSection.value}
		tabs={
			[{
				key: ALERTS.PRICE_COMPARISON,
				label: 'Price Comparison',
				disabled: isPriceComparisonTabLoading.value || isPriceComparisonTabEmpty.value,
				value: ALERTS.PRICE_COMPARISON,
				iconPosition: 'end',
				icon: isPriceComparisonTabLoading.value
					? <LoadingIconSeeker/>
					: <IconSeeker icon={ALERTS_ICONS[ALERTS.PRICE_COMPARISON]}/>
			}, {
				key: ALERTS.NO_AVAILABILITY,
				label: 'Not Available',
				disabled: isNoAvailabilityTabLoading.value || isNoAvailabilityTabEmpty.value,
				value: ALERTS.NO_AVAILABILITY,
				iconPosition: 'end',
				icon: isNoAvailabilityTabLoading.value
					? <LoadingIconSeeker/>
					: <IconSeeker icon={ALERTS_ICONS[ALERTS.NO_AVAILABILITY]}/>
			}, {
				key: ALERTS.PRICE_CHANGE,
				label: 'Price Change',
				disabled: isPriceChangeTabLoading.value || isPriceChangeTabEmpty.value,
				value: ALERTS.PRICE_CHANGE,
				iconPosition: 'end',
				icon: isPriceChangeTabLoading.value
					? <LoadingIconSeeker/>
					: <IconSeeker icon={ALERTS_ICONS[ALERTS.PRICE_CHANGE]}/>
			}, {
				key: ALERTS.MIN_MAX_PRICE,
				label: 'Min & Max Price',
				disabled: isMinMaxPriceTabLoading.value || isMinMaxPriceTabEmpty.value,
				value: ALERTS.MIN_MAX_PRICE,
				iconPosition: 'end',
				icon: isMinMaxPriceTabLoading.value
					? <LoadingIconSeeker/>
					: <IconSeeker icon={ALERTS_ICONS[ALERTS.MIN_MAX_PRICE]}/>
			}, {
				key: ALERTS.RATING,
				label: 'Rating',
				disabled: isRatingTabLoading.value || isRatingTabEmpty.value,
				value: ALERTS.RATING,
				iconPosition: 'end',
				icon: isRatingTabLoading.value
					? <LoadingIconSeeker/>
					: <IconSeeker icon={ALERTS_ICONS[ALERTS.RATING]}/>
			}]
		}
	/>
}